const getters = {
  userInfo: state => state.user.userInfo,
  token: state => state.user.token,
  isLogin: state => state.user.isLogin,
  host: state => state.user.host,
  isActive: state => state.user.isActive,
  carNum: state => state.car.carNum,
  searchData: state => state.user.searchData,
  searchWay: state => state.user.searchWay,
  circleList: state => state.user.circleList,
  circleListTotal: state => state.user.circleListTotal,
  searchKind: state => state.user.searchKind,
  footerIndex: state => state.user.footerIndex
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js